@import '../../../../../constants/spacing.module.less';

.default-cs-btn {
  height: auto;
  line-height: normal;
  min-height: 32px;
  min-width: 128px;
  margin-right: @space-16;
}
